import { useQuery, useMutation } from "@tanstack/react-query";
import { dropoutVolunteerApiService } from "./dropoutvolunteer.api";

interface ApiResponse<T = any> {
  data: T;
  message: string;
  statusCode: number;
}

export const useDropoutVolunteerService = ({
  searchText = "",
  currentPage = 1,
  pageSize = 10,
  enableSelectAll = false,
  studyid = null,
  volunteerdropoutid = null,
}: {
  searchText?: string;
  currentPage?: number;
  pageSize?: number;
  enableSelectAll?: boolean;
  studyid?: number | null;
  volunteerdropoutid?: number | null;
} = {}) => {
  const SelectAllQuery = useQuery({
    queryKey: ["dropout-volunteer-select-all", searchText, currentPage, pageSize, studyid],
    queryFn: () =>
      dropoutVolunteerApiService.getSelectAllData({
        searchText,
        currentPage,
        pageSize,
        studyid: Number(studyid),
      }),
    enabled: enableSelectAll && !!studyid,
  });

  const SelectQuery = useQuery({
    queryKey: ["dropout-volunteer-select", volunteerdropoutid],
    queryFn: () => dropoutVolunteerApiService.getSelectData(Number(volunteerdropoutid)),
    enabled: !!volunteerdropoutid,
  });

  const InsertMutation = useMutation<ApiResponse, Error, any>({
    mutationFn: (payload: any) => dropoutVolunteerApiService.insertData(payload),
  });

  const UpdateMutation = useMutation<ApiResponse, Error, any>({
    mutationFn: (payload: any) => dropoutVolunteerApiService.updateData(payload),
  });

  const VerifyMutation = useMutation<ApiResponse, Error, any>({
    mutationFn: (payload: any) => dropoutVolunteerApiService.verifyData(payload),
  });

  const DeleteMutation = useMutation<ApiResponse, Error, any>({
    mutationFn: (payload: any) => dropoutVolunteerApiService.deleteData(payload),
  });

  return {
    SelectAllQuery,
    SelectQuery,
    InsertMutation,
    UpdateMutation,
    VerifyMutation,
    DeleteMutation,
  };
};

